import { useCallback, useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import PropTypes from "prop-types";

// Skeleton
import { SLSAPayPlanLayerReloader } from "@/PayPlans/components/Html/SLSAPayPlanLayerReloader";
import { Grid } from "@mui/material";
import ReportButtonLink from "../Buttons/ReportButtonLink";
//Icons
import PdfIcon from "@/assets/icons/svg/pdf.svg";
import EmptyBody from "../Basics/EmptyBody";
// Images
import empty from "@/assets/images/commons/empty.png";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

const options = {
	cMapUrl: "/cmaps/",
	standardFontDataUrl: "/standard_fonts/",
};

export function PdfViewer(props) {
	const { fileName, file = null, isMyPayPlan = false } = props || {};
	const [numPages, setNumPages] = useState(null);

	function onDocumentLoadSuccess(docProps) {
		const numberOfPages = isMyPayPlan ? docProps.numPages : docProps.numPages - 1;
		setNumPages(numberOfPages);
	}

	const renderDocument = useCallback(
		(localFile) => {
			if (!localFile) {
				return null;
			}

			return (
				<Grid>
					<ReportButtonLink
						title={" "}
						to={file || ""}
						fileName={fileName}
						startIcon={<img src={String(PdfIcon)} />}
						sx={{
							position: "relative",
							top: "10px",
							left: "900px",
							zIndex: 10,
							backgroundColor: "transparent",
							width: "40px",
							height: "40px",
							borderRadius: "50%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							"&:hover": {
								backgroundColor: "rgba(0, 0, 0, 0.04) !important",
								cursor: "pointer",
								"& a": {
									backgroundColor: "transparent !important",
								},
							},
							"& a": {
								marginLeft: "6px",
								padding: "0px",
								minWidth: "25px",
								width: "25px !important",
								height: "16px !important",
							},
						}}
					/>
					<Document
						file={localFile}
						onLoadSuccess={onDocumentLoadSuccess}
						loading={<SLSAPayPlanLayerReloader />}
						className={{ position: "relative" }}
						error={
							<EmptyBody
								image={empty}
								title={"No Pay Plans PDF."}
								bodyHeight={"570px"}
								sx={{
									boxShadow: "none !important",
								}}
							/>
						}
					>
						{Array.from(Array(numPages), (_el, index) => (
							<Page
								key={`page_${index + 1}`}
								pageNumber={index + 1}
								scale={1.35}
								loading=""
								renderTextLayer={true}
								renderAnnotationLayer={false}
							/>
						))}
					</Document>
				</Grid>
			);
		},
		[numPages]
	);

	useEffect(() => {
		return () => {
			setNumPages(null);
		};
	}, []);

	return renderDocument(file);
}

PdfViewer.propTypes = {
	fileName: PropTypes.string.isRequired,
	file: PropTypes.string.isRequired,
	isMyPayPlan: PropTypes.bool,
};

export default PdfViewer;
